import React, {useState} from "react"
import './promotions.scss';

function Promotions( {handleModal}) {

    const [codeValue, setCodeValue] = useState(undefined);

    const handleRedeem = () => {
        console.log(codeValue)
        codeValue === 'SOYEL10MIL' ? handleModal({open: true, content: 'success10k'}) : handleModal({open: true, content: 'error'});
    }

    const handleChange = (e) => {
        setCodeValue(e.target.value.toUpperCase())
    }

    return (
        <section id="ofertas" className="scroller">
            <h3>Ofertas</h3>
            <div className="background">
                <article>
                    <p>Estas son las promociones que tenemos disponibles:</p>
                    <table>
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Qué necesitas</th>
                                <th>Descuento</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Estudiante</td>
                                <td>Presentando tu carnet de estudiante en la taquilla.</td>
                                <td>25%</td>
                            </tr>
                            <tr>
                                <td>Familia numerosa</td>
                                <td>Necesitas tu acreditación de familia numerosa.</td>
                                <td>50%</td>
                            </tr>
                            <tr>
                                <td>Niños</td>
                                <td>Menores de 6 años</td>
                                <td>Gratis</td>
                            </tr>
                            <tr>
                                <td>Jubilados</td>
                                <td>Enséñanos tu documento de identidad al entrar.</td>
                                <td>Gratis</td>
                            </tr>
                            <tr>
                                <td>Grupos</td>
                                <td>Más de 10 personas.</td>
                                <td>Consultar</td>
                            </tr>
                        </tbody>
                    </table>
                </article>
            </div>
            <div className="background">
                <article>
                    <p>
                        ¿Tienes un código promocional? ¡Puedes canjearlo aquí!
                    </p>
                    <form>
                        <label htmlFor="code">Introduce tu código <small>(10 caracteres)</small>:</label>
                        <input className="textInput" type="text" value={codeValue} onChange={handleChange} id="code" name="code" required minLength="10" maxLength="10" size="10" placeholder="CODIGOAQUI" />
                        <input className="buttonInput" type="button" value="Canjear" onClick={handleRedeem}/>
                    </form>
                </article>
            </div>
        </section>
    );
}

export default Promotions;
